/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index img to autogenerate all the elements and extensions
 * Used by "prepareImgs"
 */

import Img from './img/Img'
export * from './img/Img'
export default Img
